import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Row, Col, Form, Input, Select, message, DatePicker, Table, Space, Drawer, Modal, Spin } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import "moment-timezone";
import { Scrollbars } from 'react-custom-scrollbars';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import { PlusCircleOutlined, InfoCircleOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import FeatherIcon from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { setEditCall, setExPoCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { AccountsByAccountType, FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { FetchDealByAccount, createDeals } from '../../../Api/Services/DealApiService';
import { FetchContactByAccount } from '../../../Api/Services/ContactApiService';
import { getAllUsersData, getBussinesDaysForStaffRole } from '../../../Api/Services/CommonApiService'
import { getProjectList, getProductDetails } from '../../../Api/Services/Productapiservice'
import { FetchAllServiceLines } from '../../../Api/Services/ServiceLineApiService'
import { findAllStaffRoleByReportingUser, getByAddStaffRoleId } from '../../../Api/Services/StaffRoleApiService'
import { BasicFormWrapper, VerticalFormStyleWrap } from '../../styled'
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import {
    getAllCustomGroupByEntity, findAllCustomOptionsByDropdown,
    findAllCustomFieldsByGroupAndEntity,
} from '../../../Api/Services/CustomeUIApiService';
import { convertCurrency, ExchangeCurrency } from '../Filters/FilterConditions';
import AllCancelPopup from '../Popup/AllCancelPopup';
import { SaveIcon, CancelIcon } from '../../../components/Icons/Icons';
import CommonFormFields from '../CustomizeUi/DynamicFieldGroup';

const { Option } = Select;

export const dealFieldConfig = {
    subtype: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.dealTypeField !== "New" && sharedProps?.dealTypeField !== "Expansion",
    }),
    parentDealId: (sharedProps) => ({
        required: sharedProps?.dealTypeField === "Expansion",
        disabled: false,
    }),
    commitStatus: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "won" || sharedProps?.pipeLineField?.toLowerCase() === "negotiation",
        disabled: sharedProps?.pipeLineField?.toLowerCase() === "prospecting" || sharedProps?.pipeLineField?.toLowerCase() === "qualification" || sharedProps?.pipeLineField?.toLowerCase() === "discovery"
    }),
    contactPerson: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: false,
    }),
    expectedDealLength: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() === "won",
        callback: sharedProps?.setChangeDealMargin,
        reset: "Yes"
    }),
    winProbability: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() === "won" || sharedProps?.pipeLineField?.toLowerCase() === "lost",
        callback: sharedProps?.setWinProbability,
        reset: "Yes"
    }),
    forecastedValue: () => ({
        required: false,
        disabled: true,
    }),
    expectedClosureDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting",
        disabled: false,
        validationType: "dateBefore",
        dependsOn: ["revenueStartDate"],
        disabledDate: (current) => {
            const start = sharedProps?.form.getFieldValue("revenueStartDate");
            const end = sharedProps?.form.getFieldValue("revenueEndDate");
            return current && (
                current.isBefore(moment(), "day") ||
                (start && current.isAfter(start, 'day')) ||
                (end && current.isAfter(end, 'day'))
            );
        }
    }),
    revenueStartDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField?.toLowerCase() !== "empanelment",
        disabled: sharedProps?.typeAction === "Staff Augmentation",
        validationType: "startAfterClosureAndBeforeEnd",
        dependsOn: ["expectedClosureDate", "revenueEndDate"],
        disabledDate: (current) => {
            const closure = sharedProps?.form.getFieldValue("expectedClosureDate")
            const end = sharedProps?.form.getFieldValue("revenueEndDate");
            return current && (
                current.isBefore(moment(), "day") ||
                (closure && current.isBefore(closure, 'day')) ||
                (end && current.isAfter(end, 'day'))
            );
        }
    }),
    revenueEndDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField?.toLowerCase() !== "empanelment",
        disabled: sharedProps?.typeAction === "Staff Augmentation",
        validationType: "dateAfter",
        dependsOn: ["revenueStartDate"],
        disabledDate: (current) => {
            const start = sharedProps?.form.getFieldValue("revenueStartDate")
            const closure = sharedProps?.form.getFieldValue("expectedClosureDate")
            return current && (
                current.isBefore(moment(), "day") ||
                (start && current.isBefore(start, 'day')) ||
                (closure && current.isBefore(closure, 'day'))
            );
        }
    }),
    grossDealValue: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() !== "prospecting" && sharedProps?.dealTypeField?.toLowerCase() !== "empanelment" && sharedProps?.edit,
        disabled: (sharedProps?.typeAction !== "Request for Proposal" && sharedProps?.typeAction !== "Others") || sharedProps?.dealValueEdit === "Disabled",
        callback: sharedProps?.OndealvalueChange
    }),
    discountPercentage: (sharedProps) => ({
        required: false,
        disabled: false,
        callback: sharedProps?.setDealDiscount,
        reset: "Yes"
    }),
    dealValue: () => ({
        required: false,
        disabled: true,
    }),
    dealProfit: () => ({
        required: false,
        disabled: true,
    }),
    actualCloserDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "won" && sharedProps?.dealTypeField?.toLowerCase() !== "empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "won",
        disabledDate: sharedProps.disabledDate,
    }),
    dealHoldDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "onhold" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "onhold",
        dependsOn: ["dealRestartDate"],
        validationType: "dateBefore",
        disabledDate: sharedProps.disabledDate,
    }),
    dealRestartDate: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "onhold",
        dependsOn: ["dealHoldDate"],
        validationType: "dateAfter",
        disabledDate: sharedProps.disabledDate,
    }),
    dealLostDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "lost" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "lost",
        disabledDate: sharedProps.disabledDate,
    }),
    actualDealMargin: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "won" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "won",
    }),
    dealWonReason: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "won",
    }),
    dealHoldReason: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "onhold",
    }),
    dealLostReason: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "lost",
    }),
};
const LEAD_SPECIAL_FIELDS = {
    dealOwner: ({ edit, users }) => {
        return (
            edit ? <Select style={{ width: '100%' }}
                placeholder="Select Deal Owner"
                showSearch
                optionLabelProp="label"
                filterOption={(input, option) => {
                    const usernameElement = option.children.props.children[1].props.children[0];
                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                        const username = String(usernameElement.props.children);
                        return username.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                }}>
                {users}
            </Select> : <></>
        )
    },
    accountName: ({ edit, account, onchangeDelete, handleAccountChange }) => {
        return (
            edit ? <Select style={{ width: '100%' }}
                placeholder="Select Account Name"
                showSearch optionLabelProp="label"
                optionFilterProp="children"
                filterOption={(input, option) => {
                    const usernameElement = option.children.props.children[1].props.children[0];
                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                        const username = String(usernameElement.props.children);
                        return username.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                }
                }
                onChange={(value) => { handleAccountChange(value); onchangeDelete(value) }}
            >
                {account.filter((item) => item.accountTypeName === "Customer").map((option, i) => (
                    <Option value={option.account_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }} >
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.accountName} (${option.accountNumber})`} style={{ cursor: "default" }}>
                                    {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                        < img src={option.accountProfile} alt="profile" />
                                        :
                                        <span className="image_icon AccountIcon">
                                            {option.accountName?.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{option.accountName}</span>
                                </div>
                            </div>
                        </div>)}>
                        <div className='UserList-dropdown' title={`${option.accountName} (${option.accountNumber})`}>
                            <div>
                                {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                    < img src={option.accountProfile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.accountName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.accountName}</p>
                                <p style={{ margin: 0 }}>{option.accountNumber}</p>
                            </div>
                        </div>
                    </Option>))
                }
            </Select> :
                <></>
        )
    },
    competition: ({ edit, accountbyType }) => {
        return (
            edit ?
                <Select style={{ width: '100%' }}
                    placeholder="Select Competition Account"
                    showSearch mode="multiple" optionLabelProp="label"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                        const usernameElement = option.children.props.children[1].props.children[0];
                        if (usernameElement && usernameElement.props && usernameElement.props.children) {
                            const username = String(usernameElement.props.children);
                            return username.toLowerCase().includes(input.toLowerCase());
                        }
                        return false;
                    }
                    }
                >
                    {accountbyType.filter((item) => item.accountTypeName === "Competitor").map((option, i) => (
                        <Option value={option.account_id} key={i} label={(
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.accountName} (${option.accountNumber})`}>
                                {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                    < img src={option.accountProfile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag AccountIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                        {option.accountName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.accountName}</p>
                            </div>)}>
                            <div className='UserList-dropdown' title={`${option.accountName} (${option.accountNumber})`}>
                                <div>
                                    {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                        < img src={option.accountProfile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                        :
                                        <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.accountName?.slice(0, 1).toUpperCase()}
                                        </span>
                                    }</div>
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{option.accountName}</p>
                                    <p style={{ margin: 0 }}>{option?.accountNumber}</p>
                                </div>
                            </div>
                        </Option>))
                    }
                </Select >
                : <></>
        )
    },
    contactPerson: ({ contacts, edit }) => {
        return (
            edit ?
                <Select style={{ width: '100%' }}
                    placeholder="Select Contact Person"
                    showSearch optionLabelProp="label"
                    mode="multiple"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                        const usernameElement = option.children.props.children[1].props.children[0];
                        if (usernameElement && usernameElement.props && usernameElement.props.children) {
                            const username = String(usernameElement.props.children);
                            return username.toLowerCase().includes(input.toLowerCase());
                        }
                        return false;
                    }}>
                    {contacts.map((option, i) => (
                        <Option value={option.contacts_id} key={i} label={(
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                    < img src={option.contact_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag ContactIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                        {option.first_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                            </div>)} >
                            <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                <div>
                                    {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                        < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                        :
                                        <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.first_name?.slice(0, 1).toUpperCase()}
                                        </span>
                                    }</div>
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                    <p style={{ margin: 0 }}>{option?.email}</p>
                                </div>
                            </div>
                        </Option>))
                    }
                </Select >
                : <></>
        )
    },
    parentDealId: ({ edit, dealTypeField, dealMapList, dealId }) => {
        return (
            edit ? <Select optionLabelProp="label"
                optionFilterProp="children" disabled={dealTypeField !== "Expansion"}
                filterOption={(input, option) => {
                    const usernameElement = option.children.props.children[1].props.children[0];
                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                        const username = String(usernameElement.props.children);
                        return username.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                }}
                style={{ width: '100%' }} placeholder="Select Parent Deal"  >
                {dealMapList.filter((item) => item.deals_id !== dealId).map((option, i) => (
                    <Option value={option.deals_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }} >
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.deal_name} (${option.pipelineStage})`} style={{ cursor: "default" }}>
                                    {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                        < img src={option.deal_profile} alt="profile" />
                                        :
                                        <span className="image_icon DealIcon">
                                            {option.deal_name?.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{option.deal_name}</span>
                                </div>
                            </div>
                        </div>)}>
                        <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                            <div>
                                {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                    < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.deal_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                                <p style={{ margin: 0 }}>{option?.pipelineStage}</p>
                            </div>
                        </div>
                    </Option>))
                }
            </Select>
                : <></>
        )
    }
};
// const DEFAULT_DROPDOWN_FIELDS = ["dealOwner", "accountName", "competition", "contactPerson"];
// const excludedFields = ["title", "firstName", "lastName", "designation", "leadOwner", "accountName", "industry", "rating", "nomOfEmployees", "annualRevenue", "website"];
// const excludedType = ["FileUpload", "MultiFileUpload"];
// const DEFAULT_DROPDOWN_DISPLAY_FIELDS = {};

function AddNew({ UrlId, FromPage, setCratePage, GetAll, dataForDeal, CallBackTrigger }) {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'deals')?.customEntityId
    const ProfileData = localData.profile
    const profile = ProfileData
    const defaultCurrency = localData.currency
    const pageTypes = "Deal";
    const [form] = Form.useForm();
    const [users, setUsers] = useState([])
    const [tempWinProp, setTempWinProp] = useState()
    const [edit, setEdit] = useState(false)
    const [account, setAccount] = useState([])
    const [accountbyType, setAccountbyType] = useState([])
    const [pipeLineStage, setPipelineStage] = useState([])
    // const [companyId, setCompayId] = useState()
    const [editField, setEditField] = useState(false)
    const [pipelineData, setPipelineData] = useState()
    const [pipeLineField, setPipeLineField] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [drawerPage, setDrawerPage] = useState()
    const [dealTypeField, setDealTypeField] = useState()
    const [typeAction, setTypeAction] = useState()
    const [productdata, setProductdata] = useState([])
    const [contacts, setContacts] = useState([])
    const [displayData, setDisplayData] = useState()
    const [winProbability, setWinProbability] = useState()
    const [dealDiscount, setDealDiscount] = useState()
    const [serviceLineData, setServiceLineData] = useState([])
    const [dealValueEdit, setDealValueEdit] = useState()
    const [editableType, setEditableType] = useState(false)
    const [oldPipeline, setOldPipeline] = useState()
    const [OldFixed, setOldFixed] = useState()
    const [staffRoleData, setStaffRoleData] = useState([])
    const [dealValues, setDealValue] = useState(0)
    const [totalDeal, setTotalDeal] = useState(0)
    const [dealId] = useState()
    // const [dataPermissions, setDataPermissions] = useState()
    const [dealMapList, setDealMapList] = useState([])
    const [changeDealMargin, setChangeDealMargin] = useState()
    const [changeDealMargin2] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const [allFieldStructure, setAllFieldStructure] = useState([]);
    const [customGroups, setCustomGroups] = useState([]);
    const [customFields, setCustomFields] = useState();
    const [images, setImages] = useState({});
    const [deleteOptions, setDeleteOptions] = useState({});
    const [fileLists, setFileLists] = useState({});
    const [dealInitial, setDealInitial] = useState()
    const [optionsMap, setOptionsMap] = useState({});
    const [dataDisables, setDataDisables] = useState({ isDisable: false, allow: false, id: null, profile: null });
    const setImage = (fieldKey, url) =>
        setImages(prev => ({ ...prev, [fieldKey]: url }));
    const setDeleteOption = (fieldKey, bool) =>
        setDeleteOptions(prev => ({ ...prev, [fieldKey]: bool }));
    const setFileList = (fieldKey, list) =>
        setFileLists(prev => ({ ...prev, [fieldKey]: list }));
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const RequiredDateFormating = (dateString) => {
        const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        return formattedDate;
    }
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    // get linked data permission
    // Update/Delete
    // const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
    //     if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
    //     const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
    //     const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
    //     const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
    //     return hasRolePermission && hasDataPermission;
    // };
    const [formDatas, setFormDatas] = useState([
        {
            dealProductId: null,
            productCategory: null,
            productLicenseSellingPriceUnitMonth: null,
            numberOfUnits: null,
            licenseDuration: null,
            total: '',
        },
    ]);
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const requiredFields = ['dealProductId', 'numberOfUnits', 'licenseDuration'];
    const isFormDataValid = formDatas.every(formData => {
        return requiredFields.every(field => {
            const value = formData[field];
            return value && value !== undefined && value !== '';
        });
    });
    const [servicesData, setServiceData] = useState([
        {
            serviceName: null,
            serviceLineId: null,
            serviceLineCost: null,
        },
    ]);
    const isservicesDataValid = servicesData.every(formData => {
        return Object.values(formData).every(value => value && value !== undefined && value !== '');
    });
    const [roleData, setRoleData] = useState([
        {
            addStaffRoleId: null,
            country: null,
            rolePerDayRate: null,
            startDate: null,
            endDate: null,
            totalValue: null,
        },
    ]);
    async function getAllAccoutbyType() {
        try {
            const data = await AccountsByAccountType()
            setAccountbyType(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const assignPipelineKeys = (pipelines) => {
        let currentKey = pipelines.find(p => p.optionType === "Default" && p.optionKey)?.optionKey || null;
        return pipelines.map((item) => {
            if (item.optionType && item.optionKey) {
                currentKey = item.optionKey;
            }
            return {
                ...item,
                optionKey: currentKey,
            };
        });
    };
    const fetchDropdownOptions = async () => {
        const allAttrs = Object.values(customFields || {}).flat();
        const dropdownIds = [...new Set(
            allAttrs
                .filter(attr => attr.dropdownId)
                .map(attr => attr.dropdownId)
        )];
        if (!dropdownIds.length) return;
        const results = await Promise.allSettled(
            dropdownIds.map(id => findAllCustomOptionsByDropdown(id))
        );
        const map = results.reduce((acc, result, index) => {
            const attr = allAttrs.find(a => a.dropdownId === dropdownIds[index]);
            if (result.status === 'fulfilled') {
                // acc[dropdownIds[index]] = result.value
                //     .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
                //     .map(item => ({
                //         value: item.customDropdownOptionId,
                //         label: item.option,
                //         optionKey: item.optionKey,
                //     }));
                let options = result.value
                    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
                if (attr?.fieldKey === "pipelineStage") {
                    options = assignPipelineKeys(options);
                }
                acc[dropdownIds[index]] = options.map(item => ({
                    value: item.customDropdownOptionId,
                    label: item.option,
                    optionKey: item.optionKey,
                }));
            } else {
                acc[dropdownIds[index]] = [];
                message.error(`Failed to load "${attr?.dropdownType}" dropdown`);
            }
            return acc;
        }, {});
        setOptionsMap(map);
    };
    const fetchCustomGroupsAndFields = async () => {
        try {
            const groups = await getAllCustomGroupByEntity(ENTITY_ID);
            const sorted = [...(groups || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            const results = await Promise.all(
                sorted.map(group => findAllCustomFieldsByGroupAndEntity(ENTITY_ID, group.customFieldGroupId))
            );
            const fieldsMap = {};
            sorted.forEach((group, index) => {
                fieldsMap[group.customFieldGroupId] = [...(results[index] || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            });
            const allFields = Object.values(fieldsMap).flat();
            const structure = allFields.map((field) => ({
                entityId: field.entityId,
                fieldId: field.fieldId,
                fieldKey: field.fieldKey,
                fieldType: field.fieldType,
                fieldLabel: field.fieldLabel,
                customFieldType: field.customFieldType,
                dropdownId: field.dropdownId,
                dropdownType: field.dropdownType,
                value: field.fieldType === 'MultiFileUpload' ? [] :
                    field.fieldType === "CheckBox" ? false : null,
            }));
            batchedUpdates(() => {
                setCustomGroups(sorted);
                setCustomFields(fieldsMap);
                setAllFieldStructure(structure);
            });
        } catch {
            message.error("Failed to load custom fields");
        }
    };
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName?.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data;
            if (displayData?.account_id) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === displayData?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { accountName: displayData?.accountName, account_id: displayData?.account_id, accountTypeName: "Customer" }];
                }
            }
            if (FromPage === "ContactPage" && dataForDeal) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === dataForDeal?.contactDetails?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { accountName: dataForDeal?.contactDetails?.account_name, account_id: dataForDeal?.contactDetails?.account_id, accountTypeName: "Customer", accountNumber: dataForDeal?.contactDetails?.account_number, accountProfile: dataForDeal?.contactDetails?.account_profile }];
                }
            }
            setAccount(accountInfo)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getComitStatus = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "commitStatus")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.find(item => item.option === "Soft Commit")
            form.setFieldsValue({
                commitStatus: OriginalOrder.customDropdownOptionId
            })
        }
        catch (error) {
            message.error(error)
        }
    };
    const handlePipeLineChange = (pipeLineStage, value, winData) => {
        const pipelineOgName = pipeLineStage.find(item => item.customDropdownOptionId === value)
        form.setFieldsValue({ pipelineStage: value })
        setPipelineData(value)
        setPipeLineField(pipelineOgName.optionKey)
        if (pipelineOgName.optionKey.toLowerCase() !== "prospecting" && pipelineOgName.optionKey.toLowerCase() !== "qualification" && pipelineOgName.optionKey.toLowerCase() !== "discovery") {
            getComitStatus()
        }
        else {
            form.setFieldsValue({
                commitStatus: null
            })
        }
        if (pipelineOgName.optionKey.toLowerCase() !== "won") {
            form.setFieldsValue({
                actualCloserDate: null,
                actualDealMargin: null,
                dealWonReason: null
            });
        }
        if (pipelineOgName.optionKey.toLowerCase() !== "lost") {
            form.setFieldsValue({
                dealLostDate: null,
                dealLostReason: null
            });
        }
        if (pipelineOgName.optionKey.toLowerCase() !== "onhold") {
            form.setFieldsValue({
                dealHoldDate: null,
                dealHoldReason: null,
                dealRestartDate: null
            });
        }
        if (pipelineOgName.optionKey.toLowerCase() === "onhold" || pipelineOgName.optionKey.toLowerCase() === "lost") {
            setOldPipeline(OldFixed)
        } else {
            setOldPipeline(null)
        }
        if (pipelineOgName.optionKey.toLowerCase() === "won" || pipelineOgName.optionKey.toLowerCase() === "lost") {
            form.setFieldsValue({
                winProbability: pipelineOgName.optionKey.toLowerCase() === "won" ? "100" : "0"
            })
            setWinProbability(pipelineOgName.optionKey.toLowerCase() === "won" ? "100" : "0")
        } else {
            // eslint-disable-next-line no-lonely-if
            if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                form.setFieldsValue({
                    winProbability: winData
                })
                setWinProbability(winData)
            }
        }
    }
    const handleAccountChange = async (value) => {
        try {
            const response = await FetchContactByAccount(value)
            setContacts(response)
        }
        catch (error) {
            message.error(error)
        }
        if (value) {
            try {
                const DealList = await FetchDealByAccount(value)
                setDealMapList(DealList)
            }
            catch (error) {
                message.error(error)
            }
        }
    }
    const onchangeDelete = (value) => {
        if (value) {
            form.setFieldsValue({
                contactPerson: [],
                parentDealId: null
            })
        }
    }
    const handleDealTypeChange = (value, option) => {
        setDealTypeField(option?.children)
        if (option.children === "Empanelment") {
            form.setFieldsValue({
                subtype: null,
                dealValue: 0,
                grossDealValue: 0,
                dealProfit: 0,
            });
        }
        if (option.children !== "Expansion") {
            form.setFieldsValue({
                parentDealId: null
            })
        }
    }
    function totalCalculation() {
        let sum = 0;
        let totalsum = 0;
        let Fvalue = 0;
        let profit = 0;
        let ChcekdealValueEdit;
        if (typeAction === "Product and Services" || typeAction === "Request for Proposal" || typeAction === "Others") {
            if (isFormDataValid || isservicesDataValid) {
                if (formDatas.length === 0 && servicesData.length === 0) {
                    sum = Number(dealValues) || 0;
                    setDealValueEdit()
                    ChcekdealValueEdit = undefined
                }
                else {
                    if (formDatas.length > 0) {
                        for (let i = 0; i < formDatas.length; i += 1) {
                            if (formDatas[i].total !== undefined)
                                sum += 1 * formDatas[i].total;
                        }
                    }
                    else if (!isservicesDataValid) {
                        sum = Number(dealValues) || 0;
                    }
                    if (servicesData.length > 0) {
                        for (let i = 0; i < servicesData.length; i += 1) {
                            if (servicesData[i].serviceLineCost !== undefined)
                                sum += 1 * servicesData[i].serviceLineCost;
                        }
                    }
                    else if (!isFormDataValid) {
                        sum = Number(dealValues) || 0;
                    }
                    if ((formDatas.length > 0 && isFormDataValid) || (servicesData.length > 0 && isservicesDataValid)) {
                        setDealValueEdit("Disabled")
                        ChcekdealValueEdit = "Disabled"
                    }
                    else {
                        setDealValueEdit()
                        ChcekdealValueEdit = undefined
                    }
                }
            }
            else if (typeAction === "Request for Proposal" || typeAction === "Others") {
                sum = Number(dealValues) || 0;
            }
        }
        if (typeAction === "Staff Augmentation") {
            // if (isroleDataValid) {
            for (let i = 0; i < roleData.length; i += 1) {
                if (roleData[i].totalValue !== undefined)
                    sum += 1 * roleData[i].totalValue;
            }
            // } else {
            //     sum = 0
            // }
        }
        if (!Number.isNaN(Number(dealDiscount)) && dealDiscount !== "" && dealDiscount !== 0) {
            totalsum = sum * (1 - Number(dealDiscount) / 100);
        } else {
            totalsum = sum;
        }
        if (!Number.isNaN(Number(winProbability)) && winProbability !== "" && totalDeal) {
            const dValue = 1 * totalDeal;
            Fvalue = dValue * (Number(winProbability) / 100);
        }
        if (pipeLineField?.toLowerCase() !== "won") {
            if (!Number.isNaN(Number(changeDealMargin)) && changeDealMargin !== "" && totalDeal) {
                const dValue = 1 * totalDeal;
                profit = dValue * (Number(changeDealMargin) / 100);
            }
        } else if (pipeLineField?.toLowerCase() === "won") {
            if (!Number.isNaN(Number(changeDealMargin2)) && changeDealMargin2 !== "" && totalDeal) {
                const dValue = 1 * totalDeal;
                profit = dValue * (Number(changeDealMargin2) / 100);
            }
        }
        form.setFieldsValue({
            dealValue: totalsum?.toFixed(CurencyDecimalPlace),
            rf: Fvalue?.toFixed(CurencyDecimalPlace),
            dealProfit: profit?.toFixed(CurencyDecimalPlace)
        })
        if (((typeAction !== "Request for Proposal" && typeAction !== "Others") || ChcekdealValueEdit === "Disabled")) {
            form.setFieldsValue({
                grossDealValue: sum?.toFixed(CurencyDecimalPlace),
            })
        }
        setTotalDeal(totalsum);
    }
    async function ProductApi() {
        try {
            const data = await getProjectList()
            const options = data.filter((item) => item.productActive === "Yes").map((option, i) => (
                <Option value={option.dealProductId} key={i} label={option.productName
                    // (<div style={{ display: 'flex', alignItems: 'center' }} title={`${option.productName} (${option.prodcutCategory})`}>
                    //     <div className='Div_flex2'>
                    //         <div className='share_image' title={`${option.productName} (${option.prodcutCategory})`} style={{ cursor: "default" }}>
                    //             {option.productImg !== null && option.productImg !== undefined && option.productImg !== "" ?
                    //                 < img src={option.productImg} alt="profile" />
                    //                 :
                    //                 <span className="image_icon">
                    //                     {option.productName?.slice(0, 1).toUpperCase()}
                    //                 </span>
                    //             }
                    //             <span className='div-ellipsis'>{option.productName}</span>
                    //         </div>
                    //     </div>
                    // </div>)
                }>
                    <div className='UserList-dropdown' title={`${option.productName} (${option.prodcutCategory})`}>
                        <div>
                            {option.productImg !== null && option.productImg !== undefined && option.productImg !== "" ?
                                < img src={option.productImg} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.productName?.slice(0, 1).toUpperCase()}
                                </span>
                            }
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.productName}</p>
                            <p style={{ margin: 0 }}>({option.prodcutCategory})</p>
                        </div>
                    </div>
                </Option>));
            setProductdata(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function ServiceLineApi() {
        try {
            const data = await FetchAllServiceLines()
            const options = data.map((option, i) => (
                <Option value={option.service_line_id} key={i} label={option.service_line_name
                    // (<div style={{ display: 'flex', alignItems: 'center' }} >
                    //     <div className='Div_flex2'>
                    //         <div className='share_image' title={option.service_line_name} style={{ cursor: "default" }}>
                    //             <span className="image_icon">
                    //                 {option.service_line_name?.slice(0, 1).toUpperCase()}
                    //             </span>
                    //             <span className='div-ellipsis'>{option.service_line_name}</span>
                    //         </div>
                    //     </div>
                    // </div>)
                }>
                    <div className='UserList-dropdown' title={option.service_line_name}>
                        <div>
                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                {option.service_line_name?.slice(0, 1).toUpperCase()}
                            </span>
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.service_line_name}</p>
                        </div>
                    </div>
                </Option>));
            setServiceLineData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function StaffRoleApi() {
        try {
            const data = await findAllStaffRoleByReportingUser()
            setStaffRoleData(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getPipelineStage = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "pipelineStage")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            const newPipiline = assignPipelineKeys(OriginalOrder)
            setPipelineStage(newPipiline)
            if (FromPage === "AccountPage" || FromPage === "ContactPage" || FromPage === "ListingDealCreate" || drawerPage === "CloneDeal") {
                handlePipeLineChange(newPipiline, newPipiline[0].customDropdownOptionId)
                form.setFieldsValue({
                    pipelineStage: newPipiline[0].customDropdownOptionId
                })
            }
        }
        catch (error) {
            setPipelineStage([])
            message.error(error)
        }
    };
    const getPriority = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "priority")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            form.setFieldsValue({
                priority: OriginalOrder[0].customDropdownOptionId
            })
        }
        catch (error) {
            message.error(error)
        }
    };
    async function getSelleingPrice(id) {
        try {
            const response = await getProductDetails(id)
            const price = response.sellingPricePerUnitPerMonth;
            const category = response.prodcutCategory;
            return { success: true, price, category };
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    async function getStaffRolePrice(id) {
        try {
            const datas = await getByAddStaffRoleId(id);
            const price = datas.rolePerDayRate;
            return { success: true, price };
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    const getWorkingDays = async (id, startDate, endDate) => {
        try {
            const response = await getBussinesDaysForStaffRole(id, startDate, endDate)
            return { success: true, data: response }
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    // add Product
    const handleFieldChange = async (index, fieldName, value) => {
        const updatedFormData = [...formDatas];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [fieldName]: value,
        };

        const productId = updatedFormData[index].dealProductId;
        if (productId) {
            const response = await getSelleingPrice(productId)
            if (!response.success) {
                message.error(response.message);
                updatedFormData[index].productLicenseSellingPriceUnitMonth = 0;
                updatedFormData[index].productCategory = null;
                updatedFormData[index].licenseDuration = 1;
            }
            else {
                const Value = response.price
                    ? await ExchangeCurrency(Number(response.price), ConvertRate)
                    : response.price;
                updatedFormData[index].productLicenseSellingPriceUnitMonth = Number(Value?.toFixed(CurencyDecimalPlace));
                updatedFormData[index].productCategory = response.category;
                if (response.category !== "Software") {
                    updatedFormData[index].licenseDuration = 1;
                } else {
                    updatedFormData[index].licenseDuration = updatedFormData[index].licenseDuration && updatedFormData[index].licenseDuration !== "" ?
                        updatedFormData[index].licenseDuration : 1
                }
            }
        }
        const productLicenseSellingPriceUnitMonth = parseFloat(updatedFormData[index].productLicenseSellingPriceUnitMonth || 0);
        const numberOfUnits = parseFloat(updatedFormData[index].numberOfUnits || 0);
        const licenseDuration = parseFloat(updatedFormData[index].licenseDuration || 0);
        if (productLicenseSellingPriceUnitMonth > 0 && numberOfUnits > 0 && licenseDuration > 0) {
            updatedFormData[index].total = (productLicenseSellingPriceUnitMonth * numberOfUnits * licenseDuration)?.toFixed(CurencyDecimalPlace);
        } else {
            updatedFormData[index].total = "";

        }
        setFormDatas(updatedFormData)
    };
    const addNewRow = () => {
        setFormDatas([...formDatas,
        {
            dealProductId: null,
            productCategory: null,
            productLicenseSellingPriceUnitMonth: null,
            numberOfUnits: null,
            licenseDuration: null,
            total: null,
        }]);
    };
    const removeRow = async (index) => {
        const updatedFormData = [...formDatas];
        updatedFormData.splice(index, 1);
        setFormDatas(updatedFormData);
    }
    // add services
    const addNewSerivce = () => {
        setServiceData([...servicesData,
        {
            serviceName: null,
            serviceLineId: null,
            serviceLineCost: null,
        },
        ]);
    };
    const removeservice = async (index) => {
        const updatedFormData = [...servicesData];
        updatedFormData.splice(index, 1);
        setServiceData(updatedFormData);
    };
    const handleServicesChange = async (index, fieldName, value) => {
        const updatedFormData = [...servicesData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [fieldName]: value,
        };
        setServiceData(updatedFormData);
    };
    // add roles
    const addNewRoles = () => {
        setRoleData([...roleData, {
            addStaffRoleId: null,
            country: null,
            rolePerDayRate: null,
            startDate: null,
            endDate: null,
            totalValue: null,
        }]);
    };
    const removeRoles = async (index) => {
        const updatedFormData = [...roleData];
        updatedFormData.splice(index, 1);
        setRoleData(updatedFormData);
    };
    const handleRolesChange = async (index, fieldName, value, countrys) => {
        const updatedFormData = [...roleData];
        if ((fieldName === "startDate" || fieldName === "endDate") && value) {
            const date = RequiredDateFormating(value)
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: date,
                country: countrys,
            };
        }
        else {
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                country: countrys,
            };
        }
        const staffRoleId = updatedFormData[index].addStaffRoleId;
        if (staffRoleId) {
            const response = await getStaffRolePrice(staffRoleId)
            if (!response.success) {
                message.error(response.message);
                updatedFormData[index].rolePerDayRate = 0;
            }
            else {
                const Value = response.price ?
                    await ExchangeCurrency(Number(response.price), ConvertRate)
                    : response.price;
                updatedFormData[index].rolePerDayRate = Number(Value?.toFixed(CurencyDecimalPlace));
            }
        }
        const rolePerDayRate = parseFloat(updatedFormData[index].rolePerDayRate || 0);
        let totalBusinessDays = 0;

        if (staffRoleId && updatedFormData[index].startDate && updatedFormData[index].endDate) {
            const responseData = await getWorkingDays(staffRoleId, updatedFormData[index].startDate, updatedFormData[index].endDate);
            if (!responseData.success) {
                message.error(responseData.message);
                totalBusinessDays = 0;
            }
            else {
                totalBusinessDays = responseData.data
            }
        } if (rolePerDayRate > 0 && totalBusinessDays > 0) {
            const total = rolePerDayRate * totalBusinessDays
            updatedFormData[index].totalValue = total?.toFixed(CurencyDecimalPlace)
        }
        else {
            updatedFormData[index].totalValue = ""
        }
        setRoleData(updatedFormData);
    };
    const handleTypeAction = (value, option) => {
        setTypeAction(option.children)
        if (option.children === "Staff Augmentation" && roleData.length === 0) {
            addNewRoles()
            form.setFieldsValue({
                revenueStartDate: null,
                revenueEndDate: null,
            })
        }
        if (option.children === "Request for Proposal" || option.children === "Product and Services") {
            if (formDatas.length === 0) {
                addNewRow()
            }
            if (servicesData.length === 0) {
                addNewSerivce()
            }
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const ProductColumns = [
        {
            title: 'Product Name',
            dataIndex: 'PrdutName',
            key: 'PrdutName',
            width: '18%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Select style={{ width: "100%" }}
                        showSearch optionLabelProp="label"
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                            const usernameElement = option.children.props.children[1].props.children[0];
                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                const username = String(usernameElement.props.children);
                                return username.toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }
                        }
                        placeholder="Select Product"
                        // dropdownRender={(menu) => (
                        //     <>
                        //         {menu}
                        //         <Divider style={{ margin: '10px 0' }} />
                        //         <Space style={{ padding: '0 8px 4px' }}>
                        //             <Button size="small" className="button_colors" onClick={() => handleProduct(true, index, "Product")}>
                        //                 <FeatherIcon icon="plus-circle" /> Add Product
                        //             </Button>
                        //         </Space>
                        //     </>
                        // )}
                        name="dealProductId"
                        value={record.dealProductId}
                        onChange={(value) =>
                            handleFieldChange(index, 'dealProductId', value)
                        }
                    >
                        {productdata}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: `Unit Price (${defaultCurrency?.currency})`,
            dataIndex: 'PriceperU/M$',
            key: 'PriceperU/M$',
            width: '13%',
            render: (text, record, index) => (
                <Form.Item>
                    <Input pattern="^\d+(\.\d+)?$" disabled prefix={defaultCurrency?.symbol}
                        name="productLicenseSellingPriceUnitMonth"
                        value={record.productLicenseSellingPriceUnitMonth}
                        onChange={(e) =>
                            handleFieldChange(index, 'productLicenseSellingPriceUnitMonth', e.target.value)
                        }
                        placeholder="Unit Price" />
                </Form.Item>
            ),
        },
        {
            title: 'No. of Units',
            dataIndex: 'Numofunits',
            key: 'Numofunits',
            width: '5%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}><Input min={0}
                    name="numberOfUnits"
                    value={record.numberOfUnits}
                    onChange={(e) => {
                        const { value } = e.target;
                        const isValid = /^\d+(\.\d+)?$/.test(value);
                        if (value === "" || isValid) {
                            handleFieldChange(index, "numberOfUnits", value);
                        }
                    }}
                    placeholder="Number of Units" />
                </Form.Item>
            ),
        },
        {
            title: (
                <div>
                    Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="License Duration in months" />
                </div>
            ),
            dataIndex: 'LicenseDutn',
            key: 'LicenseDutn',
            width: '5%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Input min={0}
                        disabled={record.productCategory !== "Software"}
                        name="licenseDuration"
                        value={record.productCategory && record.productCategory !== "Software" ? "One off" : record.licenseDuration}
                        onChange={(e) => {
                            const { value } = e.target;
                            const isValid = /^\d+(\.\d+)?$/.test(value);
                            if (value === "" || isValid) {
                                handleFieldChange(index, "licenseDuration", value);
                            }
                        }}
                        placeholder="License Duration" />
                </Form.Item>
            ),
        },
        // {
        //     title: `Subtotal (${defaultCurrency?.currency})`,
        //     dataIndex: 'Subtotal',
        //     key: 'Subtotal',
        //     width: '20%',
        //     render: (text, record, index) => (
        //         <Form.Item>
        //             {edit ? <Input prefix={defaultCurrency?.symbol}
        //                 // type="number"
        //                 disabled min={0}
        //                 name="subtotal"
        //                 value={record.subtotal}
        //                 onChange={(e) =>
        //                     handleFieldChange(index, 'subtotal', e.target.value)
        //                 }
        //                 placeholder="Subtotal" />
        //                 : <>{defaultCurrency?.symbol} <span >
        //                     {displayData?.products[index]?.subtotal?.toLocaleString()}
        //                 </span></>}
        //         </Form.Item>
        //     ),
        // },
        // {
        //     title: 'Discount',
        //     dataIndex: 'Adjustments',
        //     key: 'Adjustments',
        //     width: '15%',
        //     render: (text, record, index) => (
        //         <Form.Item>
        //             {edit ?
        //                 <Input type="number" min={0}
        //                     addonAfter={(
        //                         <Select value={record.adjustmentType} onChange={(value) => handleFieldChange(index, 'adjustmentType', value)} style={{ width: "50px" }}>
        //                             <Option value="%">%</Option>
        //                             <Option value="-">{defaultCurrency?.symbol}</Option>
        //                         </Select>)}
        //                     name="adjustments"
        //                     value={record.adjustments}
        //                     onChange={(e) =>
        //                         handleFieldChange(index, 'adjustments', e.target.value)
        //                     }
        //                     placeholder="Discount" />
        //                 : <>{record.adjustments !== undefined &&
        //                     record.adjustments !== '' &&
        //                     record.adjustments !== null &&
        //                     (record.adjustmentType === "%" ? "%" :
        //                         defaultCurrency?.symbol)} <span >
        //                         {record.adjustments !== undefined &&
        //                             record.adjustments !== '' &&
        //                             record.adjustments !== null &&
        //                             (record.adjustmentType === "%" ?
        //                                 displayData?.products[index]?.adjustments
        //                                 : displayData?.products[index]?.adjustments?.toLocaleString()
        //                             )}
        //                     </span></>}
        //         </Form.Item>
        //     ),
        // },
        {
            title: `Total (${defaultCurrency?.currency})`,
            dataIndex: 'Total',
            key: 'Total',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Input type="text" disabled prefix={defaultCurrency?.symbol}
                        name="total"
                        value={record.total}
                        onChange={(e) =>
                            handleFieldChange(index, 'total', e.target.value)
                        }
                        placeholder="Total" />
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: '2%',
            render: (text, record, index) => {
                if (edit && formDatas.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px", }} className="fetcherDelete-Icon"
                            // onClick={() => removeRow(index, record.addProductId)}
                            onClick={() => removeRow(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            width: '2%',
            render: (text, record, index) => {
                if (edit && index === formDatas.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Product"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewRow}
                        />
                    );
                }
            },
        }
    ];
    const ServicesColumns = [
        {
            title: 'Service Name',
            dataIndex: 'ServiceName',
            key: 'ServiceName',
            width: '30%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Input placeholder='Enter Service Name'
                        name="serviceName"
                        value={record.serviceName}
                        onChange={(e) =>
                            handleServicesChange(index, 'serviceName', e.target.value)
                        } />
                </Form.Item>
            ),
        },
        {
            title: 'Service Line Name',
            dataIndex: 'ServiceLineName',
            key: 'ServiceLineName',
            width: '35%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Select style={{ width: "100%" }}
                        showSearch optionLabelProp="label"
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                            const usernameElement = option.children.props.children[1].props.children[0];
                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                const username = String(usernameElement.props.children);
                                return username.toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }
                        }
                        placeholder="Enter Service Line Name"
                        // dropdownRender={(menu) => (
                        //     <>
                        //         {menu}
                        //         <Divider style={{ margin: '10px 0' }} />
                        //         <Space style={{ padding: '0 8px 4px' }}>
                        //             <Button size="small" className="button_colors" onClick={() => handleService(true, index, "DealPageService")}>
                        //                 <FeatherIcon icon="plus-circle" /> Add Service Line
                        //             </Button>
                        //         </Space>
                        //     </>
                        // )}
                        name="serviceLineId"
                        value={record.serviceLineId}
                        onChange={(value) =>
                            handleServicesChange(index, 'serviceLineId', value)
                        }
                    >
                        {serviceLineData}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: `Service Line Cost (${defaultCurrency?.currency})`,
            dataIndex: 'ServiceLineCost',
            key: 'ServiceLineCost',
            width: '31%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}> <Input placeholder='Enter Service Line Cost' min={0} prefix={defaultCurrency?.symbol}
                    name="serviceLineCost"
                    value={record.serviceLineCost}
                    onChange={(e) => {
                        const { value } = e.target;
                        if (value === "") {
                            handleServicesChange(index, "serviceLineCost", value);
                            return;
                        }

                        // Allow only numeric input with optional decimal
                        const basicNumberCheck = /^\d+(\.\d*)?$/;
                        if (!basicNumberCheck.test(value)) return;

                        // Allow only up to CurencyDecimalPlace decimal places
                        const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                        if (!decimalRegex.test(value)) return;

                        // All checks passed
                        handleServicesChange(index, "serviceLineCost", value);
                    }} />
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: '2%',
            render: (text, record, index) => {
                if (edit && servicesData.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px" }} className="fetcherDelete-Icon"
                            // onClick={() => removeservice(index, record.serviceId)}
                            onClick={() => removeservice(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            width: '2%',
            render: (text, record, index) => {
                if (edit && index === servicesData.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Services"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewSerivce}
                        />
                    );
                }
            },
        }
    ];
    const StaffColumns = [
        {
            title: 'Role Name',
            dataIndex: 'RoleName',
            key: 'RoleName',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Select style={{ width: "100%" }}
                        showSearch
                        optionFilterProp="children" optionLabelProp="label"
                        filterOption={(input, option) => {
                            const usernameElement = option.children.props.children[1].props.children[0];
                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                const username = String(usernameElement.props.children);
                                return username.toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }
                        }
                        placeholder="Select Staff Role"
                        name="addStaffRoleId"
                        value={record.addStaffRoleId}
                        onChange={(value, option) => {
                            handleRolesChange(index, 'addStaffRoleId', value, option.name);
                        }}
                    >
                        {staffRoleData.map((option, i) => (
                            <Option value={option.addStaffRoleId} key={i} name={option.country}
                                label={option.roleName
                                    // (<div style={{ display: 'flex', alignItems: 'center' }} >
                                    //     <div className='Div_flex2'>
                                    //         <div className='share_image' title={`${option.roleName} (${option.country})`} style={{ cursor: "default" }}>
                                    //             <span className="image_icon">
                                    //                 {option.roleName?.slice(0, 1).toUpperCase()}
                                    //             </span>
                                    //             <span className='div-ellipsis'>{option.roleName}</span>
                                    //         </div>
                                    //     </div>
                                    // </div>)
                                }>
                                <div className='UserList-dropdown' title={`${option.roleName} (${option.country})`}>
                                    <div>
                                        <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.roleName?.slice(0, 1).toUpperCase()}
                                        </span>
                                    </div>
                                    <div>
                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.roleName}</p>
                                        <p style={{ margin: 0 }}>({option.country})</p>
                                    </div>
                                </div>
                            </Option>))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: `Per Day Rate (${defaultCurrency?.currency})`,
            dataIndex: 'RolePerDayRate',
            key: 'RolePerDayRate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item> <Input placeholder='Role Per Day Rate' pattern="^\d+(\.\d+)?$" min={0}
                    name="rolePerDayRate" prefix={defaultCurrency?.symbol}
                    disabled
                    value={record.rolePerDayRate}
                    onChange={(e) =>
                        handleRolesChange(index, 'rolePerDayRate', e.target.value, record.country)
                    } />
                </Form.Item>
            ),
        },
        {
            title: 'Start Date',
            dataIndex: 'StartDate',
            key: 'StartDate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <DatePicker
                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                        value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                        name="startDate"
                        disabledDate={(current) => {
                            const closure = form.getFieldValue("expectedClosureDate");
                            const end = record.endDate ? moment(record.endDate, "YYYY-MM-DD").startOf("day") : null;

                            return current && (
                                current < moment().startOf("day") ||
                                (closure && current.isBefore(closure, 'day')) ||
                                (end && current.isAfter(end, 'day'))
                            );
                        }}
                        placeholder="Select Start Date"
                        onChange={(date, dateString) =>
                            handleRolesChange(index, 'startDate', dateString, record.country)
                        }
                    />
                </Form.Item>
            ),
        },
        {
            title: 'End Date',
            dataIndex: 'EndDate',
            key: 'EndDate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <DatePicker
                        name="endDate"
                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                        value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                        disabledDate={(current) => {
                            const start = record.startDate ? moment(record.startDate, "YYYY-MM-DD").startOf("day") : null;
                            const closure = form.getFieldValue("expectedClosureDate");
                            return current && (
                                current < moment().startOf("day") ||
                                (start && current.isBefore(start, 'day')) ||
                                (closure && current.isBefore(closure, 'day'))
                            );
                        }}
                        placeholder="Select End Date"
                        onChange={(date, dateString) =>
                            handleRolesChange(index, 'endDate', dateString, record.country)
                        }
                    />
                </Form.Item>
            ),
        },
        {
            title: `Total Value (${defaultCurrency?.currency})`,
            dataIndex: 'TotalValue',
            key: 'TotalValue',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item> <Input placeholder='Enter Total Value' disabled prefix={defaultCurrency?.symbol}
                    name="totalValue"
                    value={record.totalValue}
                    onChange={(e) =>
                        handleRolesChange(index, 'totalValue', e.target.value, record.country)
                    } />
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            // width: '5%',
            render: (text, record, index) => {
                if (edit && roleData.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px" }} className="fetcherDelete-Icon"
                            // onClick={() => removeRoles(index, record.staffRoleId)}
                            onClick={() => removeRoles(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            // width: '5%',
            render: (text, record, index) => {
                if (edit && index === roleData.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Staff Augmentation"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewRoles}
                        />
                    );
                }
            },
        }
    ];
    const OndealvalueChange = (value) => {
        setDealValue(value)
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    dealOwner: profile.userId,
                });
            }
        }
    }
    const fetchAll1 = async () => {
        await Promise.allSettled([
            fetchDropdownOptions(),
        ]);
           setTimeout(() => {
            setUiReady(true);
        }, 1000);
    };
    const fetchAll = async () => {
        await Promise.allSettled([
            AccountApi(),
            UserDetailsApi(),
            getAllAccoutbyType(),
            ProductApi(),
            ServiceLineApi(),
            StaffRoleApi(),
        ])
    };
    const getFetchTwo = async () => {
        await Promise.allSettled([
            getUserDetail(),
            getPriority()
        ])
    };
    const fetchAlld11 = async () => {
        await Promise.allSettled([
            fetchCustomGroupsAndFields(),
        ])
    };
    useEffect(() => {
        if (FromPage) {
            fetchAlld11()
        }
    }, [FromPage]);
    useEffect(() => {
        if (FromPage && displayData && customFields) {
            fetchAll1();
        }
    }, [FromPage, displayData, customFields]);
    useEffect(() => {
        if (typeAction === "Staff Augmentation" && FromPage) {
            let minStart = null;
            let maxEnd = null;
            roleData.forEach(role => {
                const { startDate, endDate } = role;
                const parsedStartDate = startDate !== null && startDate !== undefined && startDate !== "" ? startDate : null
                const parsedEndDate = endDate !== null && endDate !== undefined && endDate !== "" ? endDate : null
                if (!minStart || (parsedStartDate && parsedStartDate < minStart)) {
                    minStart = parsedStartDate;
                }
                if (!maxEnd || (parsedEndDate && parsedEndDate > maxEnd)) {
                    maxEnd = parsedEndDate;
                }
            });
            const StartDateFormate = formatDateString(minStart, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const EndDateFormate = formatDateString(maxEnd, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            form.setFieldsValue({
                revenueStartDate: minStart !== null && minStart !== undefined && minStart !== "" ? moment(StartDateFormate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD") : null,
                revenueEndDate: maxEnd !== null && maxEnd !== undefined && maxEnd !== "" ? moment(EndDateFormate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD") : null,
            })
        }
    }, [roleData, FromPage]);
    useEffect(() => {
        if (FromPage) {
            totalCalculation()
        }
    }, [formDatas, servicesData, roleData, winProbability, typeAction, dealValues, dealDiscount, totalDeal, FromPage, changeDealMargin, changeDealMargin2, pipeLineField])
    useEffect(() => {
        if (FromPage && displayData) {
            if (FromPage === "AccountPage") {
                form.setFieldsValue({
                    accountName: dataForDeal?.AccountId
                })
                handleAccountChange(dataForDeal?.AccountId)
            }
            if (FromPage === "ContactPage") {
                form.setFieldsValue({
                    accountName: dataForDeal?.AccountId,
                    contactPerson: dataForDeal?.contactId
                })
                handleAccountChange(dataForDeal?.AccountId)
            }
        }
    }, [FromPage, displayData])
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll()
        }
    }, [displayData, FromPage, editField])
    useEffect(() => {
        if (pipeLineStage.length) {
            const allValues = form.getFieldsValue(true);
            const resetTitles = {};
            Object.keys(allValues).forEach(key => {
                if (key.startsWith("title-")) {
                    resetTitles[key] = undefined;
                }
            });
            form.setFieldsValue(resetTitles);
            const formValues = allFieldStructure
                .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
                .reduce((acc, item) => {
                    acc[item.fieldKey] =
                        item.fieldType === "Multi-Dropdown" ? [] :
                            item.fieldType === "CheckBox" ? false : undefined;
                    return acc;
                }, {});
            form.setFieldsValue(formValues);
            setDealInitial({
                oldPipelineStage: null,
                staffRole: [],
                products: [],
                services: [],
            })
            setImages({});
            setDeleteOptions({});
            setFileLists({});
            setDisplayData("Create")
            setStates({ ...states, selectedRowKeys: [] });
            getFetchTwo()
            // setDataPermissions("Read,Update,Delete,Sharing")
            setEdit(true)
            setEditableType(true)
            setEditField(true)
        }
    }, [UrlId, FromPage, pipeLineStage]);
    useEffect(() => {
        if (allFieldStructure.length) {
            getPipelineStage()
        }
    }, [UrlId, FromPage, allFieldStructure]);
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
        const formValues = allFieldStructure
            .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
            .reduce((acc, item) => {
                acc[item.fieldKey] =
                    item.fieldType === "Multi-Dropdown" ? [] :
                        item.fieldType === "CheckBox" ? false : null;
                return acc;
            }, {});
        form.setFieldsValue(formValues);
        setTempWinProp()
        setFileList([])
        setDealValue(0)
        setTotalDeal(0)
        setWinProbability()
        setDealDiscount()
        setRoleData([])
        setServiceData([])
        setFormDatas([])
        handleDealTypeChange(undefined, { children: undefined })
        setTypeAction()
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setDrawerPage()
        setOldPipeline()
        setOldFixed()
        if (FromPage !== "EntityUpdate" && FromPage !== "AccountPage" && FromPage !== "ContactPage") {
            GetAll();
        }
        if (FromPage !== "EntityUpdate") {
            setCratePage();
        }
        setEdit(false);
        setEditableType(false);
        setEditField(false);
        dispatch(setEditCall(false))
        setUiReady(false)
    }
    const validateRows = (rows, requiredFields, entityName = 'Row') => {
        const rowIndex = rows.findIndex(row =>
            requiredFields.some(
                field => row[field] === null || row[field] === undefined || row[field] === ''
            )
        );
        if (rowIndex !== -1) {
            message.error(<span>
                Please complete the missing fields in Row <strong>{rowIndex + 1}</strong> under <strong>{entityName}</strong>
            </span>);
            return false; // stop execution
        }
        return true; // all rows valid
    };
    const hasAnyValue = (item) => {
        return Object.values(item).some(val => val !== null && val !== undefined && val !== '');
    };
    const isEqual = (a, b) => {
        if (a === b) return true;
        // if (typeof a !== typeof b) return false;
        if (
            (typeof a === "number" && typeof b === "string") ||
            (typeof a === "string" && typeof b === "number")
        ) {
            return String(a) === String(b);
        }
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }
        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;
            return keysA.every(key => isEqual(a[key], b[key]));
        }
        return false;
    };
    const getChangedFields = (currentStructure, initialStructure) => {
        return currentStructure.filter((currField) => {
            const initField = initialStructure.find((f) => f.fieldId === currField.fieldId);
            if (!initField) return true;
            const currValue = currField.value;
            const initValue = initField.value;
            return !isEqual(currValue, initValue);
        });
    };
    const isEqual1 = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };
    const getChangedFields1 = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual1(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        if (typeAction === "Request for Proposal") {
            if (formDatas.length > 0) {
                const anyValue = formDatas.some(row => hasAnyValue(row));
                if (anyValue) {
                    if (!validateRows(formDatas, ['dealProductId', 'numberOfUnits', 'licenseDuration'], 'Add Products')) return;
                }
            }
            if (servicesData.length > 0) {
                const anyValue = servicesData.some(row => hasAnyValue(row));
                if (anyValue) {
                    if (!validateRows(servicesData, ['serviceName', 'serviceLineId', 'serviceLineCost'], 'Add Services')) return;
                }
            }
        }
        if (typeAction === "Product and Services") {
            const productsHaveData = formDatas.some(hasAnyValue);
            const servicesHaveData = servicesData.some(hasAnyValue);
            if (!productsHaveData && !servicesHaveData) {
                message.error("Please add at least one Product or Service");
                return;
            }
            if (productsHaveData) {
                if (!validateRows(formDatas, ['dealProductId', 'numberOfUnits', 'licenseDuration'], 'Add Products')) return;
            }
            if (servicesHaveData) {
                if (!validateRows(servicesData, ['serviceName', 'serviceLineId', 'serviceLineCost'], 'Add Services')) return;
            }
        }
        if (typeAction === "Staff Augmentation") {
            if (roleData.length > 0) { if (!validateRows(roleData, ['addStaffRoleId', 'country', 'rolePerDayRate', 'startDate', 'endDate', 'totalValue'], 'Add Roles')) return; }
        }
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const currentStructure = await Promise.all(
            allFieldStructure.map(async (field) => {
                let value;
                switch (field.fieldType) {
                    case 'FileUpload':
                        value = normalizeValue(images[field.fieldKey] ?? null);
                        break;
                    case 'MultiFileUpload':
                        value = fileLists[field.fieldKey] || [];
                        break;
                    case 'Date':
                        value = values[field.fieldKey]
                            ? moment(values[field.fieldKey]).format("YYYY-MM-DD")
                            : null;
                        break;
                    case 'Number':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Percentage':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Currency':
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? await convertCurrency(ConvertRate, Number(values[field.fieldKey]))
                            : null;
                        break;
                    case 'Multi-Dropdown':
                        value = values[field.fieldKey] && values[field.fieldKey].length > 0
                            ? values[field.fieldKey].join(",")
                            : null;
                        break;
                    case 'CheckBox':
                        value = values[field.fieldKey] ?? false;
                        break;
                    default:
                        value = normalizeValue(values[field.fieldKey] ?? null);
                        break;
                }
                return { ...field, value };
            })
        );
        const convertedServicesData = await Promise.all(
            servicesData.map(async (service) => {
                const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                    convertCurrency(ConvertRate, Number(service.serviceLineCost))
                    : service.serviceLineCost
                );
                return {
                    ...service,
                    serviceLineCost: convertedCost?.toString(),
                };
            })
        );
        const convertedRoleData = await Promise.all(
            roleData.map(async (role) => {
                const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                    ? convertCurrency(ConvertRate, Number(role.rolePerDayRate))
                    : role.rolePerDayRate);
                const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== "" ?
                    convertCurrency(ConvertRate, Number(role.totalValue))
                    : role.totalValue);
                return {
                    ...role,
                    rolePerDayRate: convertedRate?.toString(),
                    totalValue: convertedTotalValue?.toString(),
                };
            })
        );
        const convertedFormDatas = await Promise.all(
            formDatas.map(async (product) => {
                const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                    ? convertCurrency(ConvertRate, Number(product.productLicenseSellingPriceUnitMonth))
                    : product.productLicenseSellingPriceUnitMonth);
                const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                    ? convertCurrency(ConvertRate, Number(product.total))
                    : product.total);
                return {
                    ...product,
                    productLicenseSellingPriceUnitMonth: convertedPrice?.toString(),
                    total: convertedTotal?.toString(),
                };
            })
        );
        const formData = {
            oldPipelineStage: normalizeValue((pipeLineField?.toLowerCase() === "onhold" || pipeLineField?.toLowerCase() === "lost") ? oldPipeline : null),
        }
        const hasValidData = (obj) =>
            obj && Object.values(obj).some(val => val !== null && val !== undefined && val !== "");
        if (typeAction === "Staff Augmentation") {
            formData.staffRole = convertedRoleData;
            formData.products = [];
            formData.services = [];
        } else if (typeAction === "Product and Services" || typeAction === "Request for Proposal") {
            formData.products = convertedFormDatas.filter(hasValidData);
            formData.services = convertedServicesData.filter(hasValidData);
            formData.staffRole = [];
        } else {
            formData.staffRole = [];
            formData.products = [];
            formData.services = [];
        }
        const updatedFields = getChangedFields1(formData, dealInitial);
        const changedFields = getChangedFields(currentStructure, allFieldStructure);
        const noDefaultChanges = changedFields.length === 0;
        const noExtraChanges = !updatedFields || Object.keys(updatedFields).length === 0;
        if (noDefaultChanges && noExtraChanges) {
            message.success("Deal updated")
            setEdit(false)
            dispatch(setEditCall(false));
            setEditField(false)
            CloseDrawer()
            return;
        }
        const defaultChanges = {};
        const customFieldValues = [];
        changedFields.forEach((field) => {
            if (field.customFieldType === "Default") {
                defaultChanges[field.fieldKey] = field.value;
            } else {
                const obj = {
                    entityId: field.entityId,
                    fieldId: field.fieldId,
                    value: field.value,
                };
                customFieldValues.push(obj);
            }
        });
        const payload = {
            ...defaultChanges,
            ...(customFieldValues.length > 0 && { customFieldValues }),
            ...(updatedFields && Object.keys(updatedFields).length > 0 && updatedFields),
        };
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await createDeals(payload)
            if (response.status === 201) {
                dispatch(setEditCall(false))
                setEditField(false)
                setEdit(false)
                loadingRef.current = false;
                setDoubleClick(false)
                hideMessage();
                if (response?.data === AutomationMessage) {
                    if (FromPage === "ContactPage") {
                        dispatch(setExPoCall(true));
                        successMessage("Automation rule triggered", response?.data)
                        setTimeout(() => {
                            dispatch(setExPoCall(false));
                            CloseDrawer()
                        }, 3000);
                    }
                    else if (FromPage === "AccountPage" && pipeLineField === "Won") {
                        dispatch(setExPoCall(true));
                        successMessage("Automation rule triggered", response?.data)
                        setTimeout(() => {
                            dispatch(setExPoCall(false));
                            CloseDrawer()
                        }, 3000);
                    }
                    else {
                        setTimeout(() => {
                            CloseDrawer()
                        }, 2000);
                        successMessage("Automation rule triggered", response?.data)
                    }
                }
                else if (response?.data === ApprovalMessage) {
                    setTimeout(() => {
                        CloseDrawer()
                    }, 2000);
                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                }
                else if (response?.data !== ApprovalMessage && response?.data !== AutomationMessage) {
                    if (FromPage === "ContactPage") {
                        dispatch(setExPoCall(true));
                        if (pipeLineField === "Won") {
                            successMessage("Deal Won",
                                <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Won.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                                </>)
                        } else {
                            successMessage("Deal created", <>
                                <img
                                    src={require('../../../static/img/defaultImages/Deal.gif')}
                                    alt="celebration"
                                    style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                />
                                <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                            </>)
                        }
                        setTimeout(() => {
                            dispatch(setExPoCall(false));
                            CloseDrawer()
                        }, 3000);
                    }
                    else if (FromPage === "AccountPage" && pipeLineField === "Won") {
                        dispatch(setExPoCall(true));
                        successMessage("Deal Won",
                            <>
                                <img
                                    src={require('../../../static/img/defaultImages/Won.gif')}
                                    alt="celebration"
                                    style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                />
                                <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                            </>)
                        setTimeout(() => {
                            dispatch(setExPoCall(false));
                            CloseDrawer()
                        }, 3000);
                    }
                    else {
                        setTimeout(() => {
                            CloseDrawer()
                        }, 2000);
                        successMessage("Deal created", <>
                            <img
                                src={require('../../../static/img/defaultImages/Deal.gif')}
                                alt="celebration"
                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                            />
                            <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                        </>)
                    }
                }
                else {
                    setTimeout(() => {
                        CloseDrawer()
                    }, 2000);
                    successMessage("Deal created", <>
                        <img
                            src={require('../../../static/img/defaultImages/Deal.gif')}
                            alt="celebration"
                            style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                        />
                        <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                    </>)
                }
                if (FromPage === "AccountPage" || FromPage === "ContactPage") {
                    CallBackTrigger("Callback")
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            message.error(error)
        }
    }
    const PageCancel1 = () => {
        setCancelConfirmOpen(true)
    }
    const leadSharedProps = useMemo(() => ({
        form, edit, combinedUrl, UrlId, displayData, users, account, dataDisables, setDataDisables, images, setImage, dealId, pipeLineField, pipeLineStage, disabledDate,
        deleteOptions, setDeleteOption, onchangeDelete, handleAccountChange, contacts, dealTypeField, dealMapList, defaultCurrency, dealValueEdit, handleDealTypeChange,
        fileLists, setFileList, pipelineData, handlePipeLineChange, tempWinProp, editableType, oldPipeline, accountbyType, dealFieldConfig, typeAction, handleTypeAction,
        setChangeDealMargin, setWinProbability, setDealDiscount, OndealvalueChange, pageTypes,
    }), [
        form, edit, combinedUrl, UrlId, displayData, users, account, dataDisables, setDataDisables, images, setImage, dealId, pipeLineField, pipeLineStage, disabledDate,
        deleteOptions, setDeleteOption, onchangeDelete, handleAccountChange, contacts, dealTypeField, dealMapList, defaultCurrency, dealValueEdit, handleDealTypeChange,
        fileLists, setFileList, pipelineData, handlePipeLineChange, tempWinProp, editableType, oldPipeline, accountbyType, dealFieldConfig, typeAction, handleTypeAction,
        setChangeDealMargin, setWinProbability, setDealDiscount, OndealvalueChange,
    ]);
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={FromPage === "EntityUpdate" ? "Update Deal" : "Create Deal"}
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={uiReady ? [
                    <div className="form_action_button">
                        <Button
                            className="gray-button" size="small"
                            onClick={() => PageCancel1()}
                        >
                            <CancelIcon height={25} width={25} />Cancel
                        </Button>
                        <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={doubleClick} loading={doubleClick}>
                            {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" ? "Update" : "Save"}
                        </Button>
                    </div>] : false
                }
            >
                {uiReady ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false} >
                                <BasicFormWrapper>
                                    <VerticalFormStyleWrap>
                                        <div className="add-product-block">
                                            <div style={{ margin: 40 }}>
                                                <Row gutter={15}>
                                                    <Col xs={24}>
                                                        <div className="add-product-content">
                                                            <CommonFormFields
                                                                groups={customGroups}
                                                                customFields={customFields || {}}
                                                                specialFields={LEAD_SPECIAL_FIELDS}
                                                                sharedProps={leadSharedProps}
                                                                optionsMap={optionsMap}
                                                                combinedUrl={combinedUrl}
                                                                moduleIcon="DealIcon"
                                                                moduleLetter={displayData?.dealName?.slice(0, 1)?.toUpperCase() || 'D'}
                                                            />
                                                            {typeAction === "Staff Augmentation" ? <>
                                                                {(roleData.length > 0 || edit) &&
                                                                    <div style={{ display: 'flex' }}>
                                                                        <Heading as="h5">{!edit ? "Role Details" : "Add Roles"}</Heading>
                                                                        {/* {roleData.length === 0 && (revenueStartDate === null || revenueEndDate == null) && <span style={{ color: "red", margin: "1px 10px 0px" }}>* Please, Add Roles for Revenue start and End Date</span>} */}
                                                                    </div>}
                                                                {roleData.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Deal-RoleTable'}`}>
                                                                                <Table
                                                                                    dataSource={roleData}
                                                                                    columns={StaffColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : <Row >{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Staff Augmentation"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewRoles}
                                                                        />} </Row>}
                                                            </> : <></>}
                                                            {typeAction === "Product and Services" || typeAction === "Request for Proposal" ? <>
                                                                {(formDatas.length > 0 || edit) && <Heading as="h5">{!edit ? "Product Details" : "Add Products"}</Heading>}
                                                                {formDatas.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Product-DealTable'}`}>
                                                                                <Table
                                                                                    dataSource={formDatas}
                                                                                    columns={ProductColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : <Row >{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Product"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewRow}
                                                                        />} </Row>}
                                                            </> : <></>}
                                                            {typeAction === "Product and Services" || typeAction === "Request for Proposal" ? <>
                                                                {(servicesData.length > 0 || edit) && <Heading as="h5">{!edit ? "Service Details" : "Add Services"}</Heading>}
                                                                {servicesData.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Service-DealTable'}`}>
                                                                                <Table
                                                                                    dataSource={servicesData}
                                                                                    columns={ServicesColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    : <Row>{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Services"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewSerivce}
                                                                        />}</Row>}
                                                            </> : <></>}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </VerticalFormStyleWrap>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> : <div className="spin">
                    <Spin />
                </div>}
            </Drawer >
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
        </>
    );
}
AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    dataForDeal: PropTypes.object.isRequired,
    CallBackTrigger: PropTypes.func.isRequired,
};
export default AddNew;